import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import PracticeMCQ from "@/pages/PracticeMCQ";
import Writing from "@/pages/Writing";
import Speaking from "@/pages/Speaking";
import Chat from "@/pages/Chat";
import Lessons from "@/pages/Lessons";
import LessonPlayer from "@/pages/LessonPlayer";
import AdminLessons from "@/pages/AdminLessons";
import Progress from "@/pages/Progress";
import ParentDashboard from "@/pages/ParentDashboard";

function Protected({ children, needsAuth = false, needsProfile = true }) {
  const { user, guest } = useAuth();
  const profile = user || guest;
  if (needsAuth && !user) return <Navigate to="/auth?mode=login" replace />;
  if (needsProfile && !profile) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route
              path="/dashboard"
              element={
                <Protected>
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/practice/:skill"
              element={
                <Protected>
                  <PracticeMCQ />
                </Protected>
              }
            />
            <Route
              path="/writing"
              element={
                <Protected>
                  <Writing />
                </Protected>
              }
            />
            <Route
              path="/speaking"
              element={
                <Protected>
                  <Speaking />
                </Protected>
              }
            />
            <Route
              path="/progress"
              element={
                <Protected>
                  <Progress />
                </Protected>
              }
            />
            <Route
              path="/chat"
              element={
                <Protected needsAuth>
                  <Chat />
                </Protected>
              }
            />
            <Route
              path="/lessons"
              element={
                <Protected>
                  <Lessons />
                </Protected>
              }
            />
            <Route
              path="/lessons/:slug"
              element={
                <Protected>
                  <LessonPlayer />
                </Protected>
              }
            />
            <Route
              path="/admin/lessons"
              element={
                <Protected needsAuth>
                  <AdminLessons />
                </Protected>
              }
            />
            <Route
              path="/parent"
              element={
                <Protected needsAuth>
                  <ParentDashboard />
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
